module.exports = __webpack_public_path__ + "static/media/li-3.ccfb4bd7.png";